import { TEST_STRIPE } from "@/src/constants";

export const STRIPE_PACKAGES = {
  NRL: {
    productId: "prod_Pl1zIqNjw83uMQ",
    price: "price_1OvVvMCgpORhomMnO9plKfBA",
    oneOffId: "prod_QI5ZoCaGVzbK2k",
    oneOffPrice: "price_1PRVOQENQKqHXVnoQvVDKcRi",
  },
  BBL: {
    // Real
    // productId: "prod_R3z6QbTTQU2l9r",
    // price: "price_1QBr7sENQKqHXVnoMo3QyfZj",
    // Test Sub
    productId: "prod_RNX9JC4Atrlyec",
    price: "price_1QUm57ENQKqHXVnoyAfR2R2U",

    oneOffId: "prod_R3z6QbTTQU2l9r",
    oneOffPrice: "price_1Qb7a0ENQKqHXVno52Zq9Y58",
  },

  FULL: {
    productId: "prod_RcOIiZQhIHFYyY",
    price: "price_1Qj9WCENQKqHXVnoCZgeC7GO",
    oneOffId: "prod_QI5ZkiY6DEcN29",
    // $1 price
    // oneOffPrice: "price_1PRW63ENQKqHXVnoaprrHMfK",
    // Full Price
    oneOffPrice: "price_1PRVNwENQKqHXVnorjTrhWga",
  },
};

export const TEST_STRIPE_PACKAGES = {
  NRL: {
    productId: "prod_OPyH7iHQxe1aNP",
    price: "price_1Nd8KoCgpORhomMnD5EhGXUK",
    oneOffId: "prod_Pl1zIqNjw83uMQ",
    oneOffPrice: "price_1OvVxsCgpORhomMnpsWZ3iPR",
  },
  BBL: {
    productId: "prod_OPyFzl6LpDcFkV",
    price: "price_1Nd8J3CgpORhomMnlXDYrKYQ",
    oneOffId: "prod_PzHg5CBqhLdEOY",
    oneOffPrice: "price_1OvVxsCgpORhomMnpsWZ3iPR",
  },
  FULL: {
    productId: "prod_OexLtuebnJRpUi",
    price: "price_1NrdQZCgpORhomMn1LIymavU",
    oneOffId: "prod_PzHwsuUHpl51Kg",
    // Full price
    // oneOffPrice: "price_1P9x7SCgpORhomMn6w3FdUjx",
    // Test price
    oneOffPrice: "price_1PRW63ENQKqHXVnoaprrHMfK",
  },
};

export const STIPE_PACKAGE_IDS = {
  test: {
    packages: TEST_STRIPE_PACKAGES,
  },
  live: {
    packages: STRIPE_PACKAGES,
  },
};

export const SRIPE_PACKAGE_ID_TO_NAME = {
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.NRL.productId]:
    "NRL Yearly Subscription",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.NRL.oneOffId]: "NRL Single Season",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.BBL.productId]:
    "BBL Yearly Subscription",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.BBL.oneOffId]: "BBL Single Season",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.FULL.productId]:
    "👑 Premium Monthly Subscription",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.FULL.oneOffId]:
    "👑 Premium Single Season",
};

export const SRIPE_PACKAGE_ID_TO_SPORT = {
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.NRL.productId]: "NRL",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.NRL.oneOffId]: "NRL",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.BBL.productId]: "BBL",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.BBL.oneOffId]: "BBL",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.FULL.productId]: "FULL",
  [STIPE_PACKAGE_IDS[TEST_STRIPE].packages.FULL.oneOffId]: "FULL",
};

export const PACKAGE_MAP = {
  prod_Pl1zIqNjw83uMQ: {
    name: "NRL",
    icon: "/images/nrl.svg",
  },
  prod_Pl21QOBaA76DAf: {
    name: "BBL",
    icon: "/images/bbl.svg",
  },
  prod_OexJt4lB7VtFkJ: {
    name: "AFL",
    icon: "/images/afl.svg",
  },
  prod_Pl1zHMOz4KBuN3: {
    name: "👑 FULL",
    icon: "/images/full.svg",
    label: "👑",
  },
};

export const PACKAGE_PRICE_MAP = {
  price_1OvVvMCgpORhomMnO9plKfBA: {
    name: "NRL",
    icon: "/images/nrl.svg",
  },
  price_1OvVxsCgpORhomMnpsWZ3iPR: {
    name: "BBL",
    icon: "/images/bbl.svg",
  },
  price_1NrdOmCgpORhomMntkCrGNhh: {
    name: "AFL",
    icon: "/images/afl.svg",
  },
  price_1OvVvxCgpORhomMnyNiR173i: {
    name: "👑 Full",
    icon: "/images/full.svg",
    label: "👑",
  },
};

export const SPORT_ICON_MAP = {
  FULL: "/images/full.svg",
  NRL: "/images/nrl.svg",
  BBL: "/images/bbl.svg",
};
